var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightSec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5513 0.293C10.7388 0.105529 10.9931 0.000213623 11.2583 0.000213623C11.5235 0.000213623 11.7778 0.105529 11.9653 0.293L15.9653 4.293C16.1528 4.48053 16.2581 4.73484 16.2581 5C16.2581 5.26516 16.1528 5.51947 15.9653 5.707L11.9653 9.707C11.7767 9.88916 11.5241 9.98995 11.2619 9.98767C10.9997 9.9854 10.7489 9.88023 10.5635 9.69482C10.3781 9.50941 10.2729 9.2586 10.2706 8.9964C10.2683 8.7342 10.3691 8.4816 10.5513 8.293L12.8443 6H1.2583C0.993084 6 0.73873 5.89464 0.551194 5.70711C0.363658 5.51957 0.258301 5.26522 0.258301 5C0.258301 4.73478 0.363658 4.48043 0.551194 4.29289C0.73873 4.10536 0.993084 4 1.2583 4H12.8443L10.5513 1.707C10.3638 1.51947 10.2585 1.26516 10.2585 1C10.2585 0.734836 10.3638 0.480528 10.5513 0.293Z",
    fill: "#149DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSec);
export default __webpack_public_path__ + "static/media/arrow_right_sec.7195cea10d0e9ca802f6c5122963c6a6.svg";
export { ForwardRef as ReactComponent };